export enum ToastType {
  SUCCESS,
  DANGER,
  INFO,
  WARNING,
  ACTION,
}

export interface IToast {
  type: ToastType;
  message: string;
  header?: string;
  classname?: string;
  delay?: number;
}
